import Component from '@glimmer/component';
import type { EmberChangeset } from 'ember-changeset';
// @ts-expect-error Ignoring UIKit type errors
import changesetGet from 'ember-changeset/helpers/changeset-get';
import type { Signature as DropdownSignature } from '../dropdown';
import Dropdown from '../dropdown.gts';
import ValidatedField from '../validated-field.gts';

interface Signature {
  Element: DropdownSignature['Element'];
  Args: {
    propertyName: string;
    onChangesetUpdate?: (changeset: EmberChangeset) => void;
    changeset: EmberChangeset;
  } & Partial<
    Pick<
      DropdownSignature['Args'],
      | 'onChange'
      | 'onSearch'
      | 'labelName'
      | 'isReadOnly'
      | 'placeholder'
      | 'isMandatory'
      | 'multipleSelection'
      | 'clearable'
      | 'allowAdditions'
      | 'translationKey'
      | 'fullTextSearch'
    >
  >;
  Blocks: DropdownSignature['Blocks'];
}

/**
 * This component manages two types of data depending of the simple selection or
 * the multiple selection.
 *
 * - A single selection manage a string
 * - A multiple selection manage an array of strings.
 *
 * It can used using a changeset or as a classic component with an
 * `onChange` callback and `selected` attribute.
 */
export default class ChangesetDropdownComponent extends Component<Signature> {
  onChange = (value: string) => {
    this.args.changeset.set(this.args.propertyName, value);
    this.args.onChangesetUpdate?.(this.args.changeset);
  };

  <template>
    <ValidatedField
      @propertyName={{@propertyName}}
      @changeset={{@changeset}}
      @errorClass='error-validated-input-display'
    >
      <Dropdown
        @selected={{changesetGet @changeset @propertyName}}
        {{! @glint-expect-error }}
        @onChange={{this.onChange}}
        @onSearch={{@onSearch}}
        @labelName={{@labelName}}
        @isReadOnly={{@isReadOnly}}
        @placeholder={{@placeholder}}
        @propertyName={{@propertyName}}
        @isMandatory={{@isMandatory}}
        @multipleSelection={{@multipleSelection}}
        @clearable={{@clearable}}
        @allowAdditions={{@allowAdditions}}
        @translationKey={{@translationKey}}
        @fullTextSearch={{@fullTextSearch}}
        ...attributes
        as |dropdown|
      >
        {{yield dropdown}}
      </Dropdown>
    </ValidatedField>
  </template>
}
